import {getRunningStates, get_all_deliver_modes} from '@/api/common/common.js'
import common from '@/utils/common'

/**
 * 初始化运营状态数据
 */
async function initRunningStates() {
    try {
        const res = await getRunningStates({})
        if (res.code === 0) {
            common.us_arr = [
                {us: '', title: '全部'},
                ...res.data.map(item => ({
                    us: item.state,
                    title: item.cn_state
                }))
            ]
            common.us_arr_normal = res.data.map(item => ({
                us: item.state,
                title: item.cn_state
            }))
            // 返回数据供后续使用
            return res.data
        }
        return []
    } catch (error) {
        console.error('获取运营状态数据失败:', error)
        throw error
    }
}

/**
 * 初始化运输模式数据
 */
async function initTransportationMode(runningStates = []) {
    try {
        const res = await get_all_deliver_modes({})
        if (res.code === 0) {
            // 创建中文国家名到国家代码的映射
            const countryMap = {}
            runningStates.forEach(item => {
                countryMap[item.cn_state] = item.state
            })
            
            // 处理运输模式数据
            const deliverModes = []
            
            res.data.forEach(mode => {
                // 从字符串中提取国家名称（如 "美国-快递" -> "美国"）
                const parts = mode.split('-')
                if (parts.length >= 2) {
                    const countryName = parts[0]
                    const nationCode = countryMap[countryName]
                    
                    deliverModes.push({
                        label: mode,
                        value: mode,
                        nation: nationCode || ''
                    })
                }
            })
            common.deliverModeArr = [
                {label: '全部', value: ''},
                ...deliverModes
            ]
            common.deliverModeArr_normal = deliverModes
        }
    } catch (error) {
        console.error('获取运输模式数据失败:', error)
        throw error
    }
}

/**
 * 应用启动初始化
 * 所有初始化任务都在这里统一管理
 */
export async function bootstrap() {
    try {
        // 先初始化运营状态数据
        const runningStates = await initRunningStates()
        
        // 再初始化运输模式数据（依赖运营状态数据）
        await initTransportationMode(runningStates)
        
        console.log('应用初始化完成')
    } catch (error) {
        console.error('应用初始化失败:', error)
        // 即使初始化失败，也允许应用继续运行
    }
}
